<template>
    <div class="pp-lottery-winnings">
        <DsTable>
            <DsRow>
                <DsCell type="th" data-test="table-winnings-1-1">Pořadí</DsCell>
                <DsCell
                    type="th"
                    v-for="(_, setIndex) in results.mainGameWinnings[0].length"
                    :key="setIndex"
                    :data-test="`table-winnings-${setIndex + 2}-1`"
                >
                    {{ setIndex + 1 }}.&nbsp;tah
                </DsCell>
            </DsRow>
            <DsRow v-for="(orderWinnings, orderIndex) in results.mainGameWinnings" :key="orderIndex">
                <DsCell :data-test="`table-winnings-1-${orderIndex + 2}`">
                    {{ orderIndex === 0 ? "Bonus" : `${orderIndex}.&nbsp;pořadí` }}
                </DsCell>
                <DsCell
                    v-for="(winning, setIndex) in orderWinnings"
                    :data-test="`table-winnings-${setIndex + 2}-${orderIndex + 2}`"
                    :key="setIndex"
                >
                    <div v-if="winning.amount && winning.wins">
                        <strong v-html="StringUtils.formatCurrency(winning.amount)"></strong>
                        <span v-html="' ' + formatNumberOfWinners(winning.wins)"></span>
                    </div>
                    <span v-else>–––</span>
                </DsCell>
            </DsRow>
        </DsTable>

        <h2 class="pp-lottery-winnings__title" v-if="results.estimatedJackpots">Předpokládané částky Jackpotů</h2>

        <DsTable v-if="results.estimatedJackpots">
            <DsRow>
                <DsCell type="th" data-test="table-jackpots-1-1">Pořadí</DsCell>
                <DsCell
                    type="th"
                    v-for="(_, i) in results.estimatedJackpots[0].length"
                    :key="i"
                    :data-test="`table-jackpots-${i + 2}-1`"
                >
                    {{ i + 1 }}.&nbsp;tah
                </DsCell>
            </DsRow>
            <DsRow v-for="(orders, orderIndex) in results.estimatedJackpots" :key="orderIndex">
                <DsCell :data-test="`table-jackpots-1-${orderIndex + 2}`">{{ orderIndex + 1 }}. pořadí</DsCell>
                <DsCell
                    v-for="(set, setIndex) in orders"
                    :data-test="`table-jackpots-${setIndex + 2}-${orderIndex + 2}`"
                    :key="setIndex"
                >
                    <strong v-html="StringUtils.formatCurrency(set)"></strong>
                </DsCell>
            </DsRow>
        </DsTable>

        <PpAddonWinnings
            v-if="results.addonWinnings"
            :lottery="Lottery.sportka"
            :winnings="results.addonWinnings"
        ></PpAddonWinnings>
        <PpSpecialPrizeWinnings
            :lottery="Lottery.sportka"
            :specialPrizes="results.specialPrizes"
        ></PpSpecialPrizeWinnings>
    </div>
</template>

<script lang="ts" setup>
import { StringUtils } from "@sazka/utils/string-utils";
import { PpDraw } from "@/lotteries/services/model/draw";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import PpAddonWinnings from "@/lotteries/product-page/components/results/pp-addon-winnings.vue";
import PpSpecialPrizeWinnings from "./pp-special-prize-winnings.vue";

defineProps<{
    results: PpDraw;
}>();

const formatNumberOfWinners = (winners: number) => `(${StringUtils.formatNumber(winners)}x)`;
</script>
